import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { MijnTokensBrowserNavigation } from '../../mijn-tokens-browser.navigation';

@Injectable({ providedIn: 'root' })
export class DeviceGuard {
    public constructor(private readonly navigation: MijnTokensBrowserNavigation) {}

    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const deviceAllowed = this.navigation.deviceAllowed();
        if (!deviceAllowed) {
            this.navigation.toStart();
        }
        return deviceAllowed;
    }
}
